import React from 'react';
import { Alert, Box, IconButton, Popover, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppSelector } from 'store/store';
import { workflowStatusLabel } from 'components/Workflow/WorkflowStatusText';
import { formatDateTime } from 'utility/formatDate';

import './WorkflowHistoryPopover.scss';

interface IProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

/**
 * Who moved a drawing to which state, and when. Newest first.
 *
 * The entries live in the shared workflow state, so while the next drawing's
 * history is on its way the previous one is still in there — hence the loading
 * state is shown rather than the rows.
 */
export const WorkflowHistoryPopover: React.FC<IProps> = ({ anchorEl, onClose }) => {
  const { history, loading, error } = useAppSelector((state) => state.workflow);

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      disableScrollLock
      slotProps={{ paper: { className: 'psf-workflow-history' } }}
    >
      <IconButton className="psf-workflow-history__close" onClick={onClose} size="small" aria-label="Schließen">
        <CloseIcon fontSize="small" />
      </IconButton>

      <Typography className="psf-workflow-history__title">Workflow-Verlauf</Typography>

      {loading && <Typography className="psf-workflow-history__loading">Wird geladen …</Typography>}

      {!loading && error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && history.length === 0 && <Typography>Kein Verlauf vorhanden.</Typography>}

      {!loading &&
        !error &&
        history.map((entry) => (
          <Box key={entry.id} className="psf-workflow-history__entry">
            <Typography>{entry.email}</Typography>
            <Typography>
              {workflowStatusLabel(entry.workflowStatusId)} am: {formatDateTime(entry.updated)}
            </Typography>
          </Box>
        ))}
    </Popover>
  );
};
